import { combineReducers } from "redux";
import cities from "./citiesReducers";
import wilayas from "./wilayasReducers";
 import fees from "./deliveryFeesReducer";
export default combineReducers({
  wilayas,
  cities,
  fees,
});
